import * as React from "react";
import { SVGProps } from "react";

const ArrowBackSvg: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  color = "#292D32",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.57 5.93 3.5 12l6.07 6.07"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.5 12H3.67"
    />
  </svg>
);

export default ArrowBackSvg;
